module.exports = __webpack_public_path__ + "img/mb@2x.50677946.png";